import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import Select from "react-select";
import Compressor from "compressorjs"
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Flatpickr from "react-flatpickr";
import { dateFormat, formatDateToISO } from 'pages/Common';
import uploadImage from "../../assets/images/uploadImage.png"
import Dropzone from "react-dropzone"
import { GetObjByPaymentModeType } from '_mock/Static_data';

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const colourStyles1 = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid #f46a6a",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}
const PurchasePaymentModel = ({ modal, toggle, PurchaseListApi, vendors }) => {
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    const [vendorId, setVendorId] = useState(0)
    const [paymentMethod, setpaymentMethod] = useState(1)
    const [amountData, setAmountData] = useState({
        TotalAmount: 0,
        TotalPaidAmount: 0,
        TotalCashAmount: 0,
        TotalUnpaidAmount: 0,
        TotalBankAmount: 0
    })



    useEffect(() => {
        if (vendorId > 0) {
            postApi(`Purchase/purchase-transactions-amounts`, {
                Id: parseInt(vendorId),
                fromDate: null,
                toDate: null,
            }).then(({ data, status }) => {
                if (status === 200) {
                    setAmountData(data)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
        }
    }, [vendorId])

    // parcel Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            payableAmount: '',
            Remark: '',
        },
        validationSchema: Yup.object({
            payableAmount: Yup.number().required("The payable Amount is required"),
        }),
        onSubmit: values => {

            if (vendorId == 0) {
                toast.error("Please Select Vendor", {
                    style: {
                        fontSize: "15px",
                    },
                })
                return false
            }
            setformSumitLoading(true)
            if (values) {
                postApi("Purchase/add-transaction", {
                    vendorId: parseInt(vendorId),
                    paidAmount: parseFloat(values.payableAmount),
                    paymentMode: parseInt(paymentMethod),
                    Remark: values.Remark || '',
                }).then(({ data, status }) => {
                    setformSumitLoading(false)
                    if (status == 400) {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    } else {
                        toast.success("Sucessfully created", {
                            style: {
                                fontSize: "15px",
                            },
                        })
                        toggle()
                        if (PurchaseListApi != '') {
                            PurchaseListApi()
                        }
                        setVendorId(0)
                        setAmountData(0)
                        validation.handleReset()
                    }
                })
            }
        },
    })

    useEffect(() => {
        setVendorId(0)
        setAmountData(0)
        validation.handleReset()
    }, [modal])

    const handeleCancel = () => {
        toggle()
        setVendorId(0)
        setAmountData(0)
        validation.handleReset()
    }

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="xl"
            style={{ width: isMobile ? "" : "850px" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    Make Payment
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row className='mb-3'>
                            <Col md={3}>
                                <Col md="12" className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Vendor
                                    </Label>
                                    <Input
                                        type="select"
                                        id="validationCustom01"
                                        className="form-control-sm"
                                        bsSize='sm'
                                        name="vendor"
                                        // onChange={validation.handleChange}
                                        onChange={e => {
                                            setVendorId(e.target.value)
                                        }}
                                        value={vendorId}
                                    >
                                        <option value={0}>Select</option>
                                        {vendors.map((item, index) => {
                                            return (
                                                <option key={index} value={item.Key}>
                                                    {item.Value}
                                                </option>
                                            )
                                        })}
                                    </Input>
                                </Col>
                                <Col md={12}>
                                    <div className="mb-2">
                                        <Label htmlFor="validationCustom03" className='required'>
                                            Payable Amt.
                                        </Label>
                                        <Input
                                            name="payableAmount"
                                            placeholder="0"
                                            type="text"
                                            className="form-control-sm"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            onKeyPress={handleKeyPress}
                                            value={validation.values.payableAmount}
                                            invalid={
                                                (validation.touched.payableAmount && validation.errors.payableAmount)
                                                    ? true
                                                    : false
                                            }
                                        />
                                        {(validation.touched.payableAmount && validation.errors.payableAmount) ? (
                                            <FormFeedback type="invalid">
                                                {"Payble Amount is required"}
                                            </FormFeedback>
                                        ) : null}
                                    </div>
                                </Col>
                                <Col md={12} className="">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Payment Mode
                                    </Label>
                                    <Input
                                        type="select"
                                        id="validationCustom01"
                                        className="form-control-sm"
                                        bsSize='sm'
                                        name="paymentMode"
                                        onChange={e => {
                                            setpaymentMethod(e.target.value)
                                        }}
                                        value={paymentMethod}
                                    >
                                        {GetObjByPaymentModeType(1, 2, 3).map((item, index) => {
                                            return (
                                                <option key={index} value={item.Value}>
                                                    {item.Key}
                                                </option>
                                            )
                                        })}
                                    </Input>
                                </Col>
                            </Col>
                            <Col md={4} className='mt-4' style={{ fontSize: "14px", textAlign: "-webkit-right" }} >
                                <table className="text-end">
                                    <tr style={{ textAlign: "end" }}>
                                        <th className="gst-amounts">
                                            <Label>
                                                Cash Paid:
                                            </Label>
                                        </th>
                                        <th className="gst-amounts2">  <i className="mdi mdi-currency-inr p-0"></i>
                                            {new Intl.NumberFormat('en-IN', {
                                                currency: 'INR',
                                                minimumFractionDigits: 2,
                                            }).format(amountData?.TotalCashAmount || 0)}
                                        </th>
                                    </tr>
                                    <tr style={{ textAlign: "end" }}>
                                        <th className="gst-amounts">
                                            <Label>
                                                Bank Paid:
                                            </Label>
                                        </th>
                                        <th className="gst-amounts2">  <i className="mdi mdi-currency-inr p-0"></i>
                                            {new Intl.NumberFormat('en-IN', {
                                                currency: 'INR',
                                                minimumFractionDigits: 2,
                                            }).format(amountData?.TotalBankAmount || 0)}
                                        </th>
                                    </tr>
                                </table>
                            </Col>
                            <Col md={5} className='mt-4' style={{ fontSize: "14px", textAlign: "-webkit-right" }} >
                                <table className="text-end">
                                    <tr style={{ textAlign: "end" }}>
                                        <th className="gst-amounts">
                                            <Label>
                                                Total Billing:
                                            </Label>
                                        </th>
                                        <th className="gst-amounts2">  <i className="mdi mdi-currency-inr p-0"></i>
                                            {new Intl.NumberFormat('en-IN', {
                                                currency: 'INR',
                                                minimumFractionDigits: 2,
                                            }).format(amountData?.TotalAmount || 0)}
                                        </th>
                                    </tr>
                                    <tr style={{ textAlign: "end" }}>
                                        <th className="gst-amounts">
                                            <Label>
                                                Total Paid Amt.(-):
                                            </Label>
                                        </th>
                                        <th className="gst-amounts2">  <i className="mdi mdi-currency-inr p-0"></i>
                                            {new Intl.NumberFormat('en-IN', {
                                                currency: 'INR',
                                                minimumFractionDigits: 2,
                                            }).format(amountData?.TotalPaidAmount || 0)}
                                        </th>
                                    </tr>
                                    <tr style={{ textAlign: "end" }}>
                                        <th className="gst-amounts">
                                            <Label>
                                                Due Amt.:
                                            </Label></th>
                                        <th className="gst-amounts2">  <i className="mdi mdi-currency-inr p-0"></i>
                                            {new Intl.NumberFormat('en-IN', {
                                                currency: 'INR',
                                                minimumFractionDigits: 2,
                                            }).format(Math.round((amountData?.TotalUnpaidAmount || 0)))}
                                        </th>
                                    </tr>
                                </table>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8}>
                                <FormGroup className="mb-2" style={{ display: "flex", gap: "10px" }}>
                                    <Label htmlFor="validationCustom03" className="">
                                        Remark:
                                    </Label>
                                    <Input
                                        name="Remark"
                                        placeholder="Enter remark here"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Remark}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <div className="d-flex justify-content-end align-items-center gap-2">
                                    <div className="text-end">
                                        <Button
                                            task-title="secondary"
                                            className="btn btn-primary me-2 btn-sm "
                                            type="button"
                                            onClick={() => handeleCancel()}
                                            color="secondary"
                                        >
                                            Cancel
                                        </Button>
                                        {formSumitLoading ? (
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                            >
                                                <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                Loading
                                            </button>
                                        ) : (
                                            <Button
                                                color="primary"
                                                task-title="primary"
                                                className="btn btn-primary btn-sm "
                                                type="submit"
                                            >
                                                Submit
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>


                    </Form>
                </ModalBody>
            </div>
        </Modal >
    )
}

export default PurchasePaymentModel